import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { ShieldCheck, X, Cookie } from 'lucide-react';

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      // Pequeño delay para que no aparezca de golpe
      const timer = setTimeout(() => setShow(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setShow(false);
    // Aquí se podrían activar scripts de terceros (GTM, GA4, etc.)
    window.location.reload(); // Recargar para activar trackers que miren localStorage
  };

  const handleDecline = () => {
    localStorage.setItem('cookie-consent', 'declined');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] p-4 md:p-6 animate-in slide-in-from-bottom-full duration-500">
      <div className="max-w-7xl mx-auto">
        <div className="bg-white rounded-2xl shadow-2xl border border-slate-200 p-6 md:p-8 flex flex-col md:flex-row items-center gap-6 relative overflow-hidden">
          {/* Decoración */}
          <div className="absolute top-0 left-0 w-1.5 h-full bg-accent" />
          
          <div className="bg-accent/10 p-4 rounded-full hidden md:block">
            <Cookie className="w-8 h-8 text-accent" />
          </div>

          <div className="flex-1 text-center md:text-left">
            <h3 className="text-xl font-serif font-bold text-primary mb-2 flex items-center justify-center md:justify-start gap-2">
              <span className="md:hidden"><Cookie className="w-5 h-5 text-accent" /></span>
              Valoramos tu privacidad
            </h3>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-3xl">
              Utilizamos cookies propias y de terceros para mejorar tu experiencia, analizar el tráfico y mostrarte contenido personalizado. Al hacer clic en "Aceptar", consientes su uso. Puedes obtener más información en nuestra <a href="/privacidad" className="text-accent hover:underline font-medium">Política de Cookies</a>.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center gap-3 w-full md:w-auto">
            <Button 
              variant="outline" 
              onClick={handleDecline}
              className="w-full sm:w-auto border-slate-200 text-slate-600 hover:bg-slate-50 order-2 sm:order-1"
            >
              Rechazar todas
            </Button>
            <Button 
              onClick={handleAccept}
              className="w-full sm:w-auto bg-primary hover:bg-primary/90 text-white order-1 sm:order-2 px-8"
            >
              Aceptar cookies
            </Button>
          </div>

          <button 
            onClick={() => setShow(false)}
            className="absolute top-4 right-4 text-slate-400 hover:text-slate-600 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
}
